
export default function set_flexible() {
  const docEl = document.documentElement;

  // 1. 将基准设计稿和基准字号抽离为常量，方便后续维护
  const PC_DESIGN_WIDTH = 1920;
  const MOBILE_DESIGN_WIDTH = 375;
  const BASE_FONT_SIZE = 16;
  const BREAK_POINT = 1024;

  // 2. 使用箭头函数重构核心逻辑
  const setRem = () => {
    // 使用 ES6 逻辑或与可选链（Optional Chaining）安全获取宽度
    const clientWidth = docEl?.clientWidth || window?.innerWidth;
    if (!clientWidth) return;

    // 运用三元运算符简化条件分支
    docEl.style.fontSize = clientWidth < BREAK_POINT
      ? `${(clientWidth / MOBILE_DESIGN_WIDTH) * BASE_FONT_SIZE}px` // 手机端
      : `${(clientWidth / PC_DESIGN_WIDTH) * BASE_FONT_SIZE}px`;   // 桌面端
  };

  // 初始化调用
  setRem();

  // 3. 监听窗口缩放，使用箭头函数与防抖优化
  let resizeTimer = null;
  window.addEventListener('resize', () => {
    const currentWidth = docEl?.clientWidth || window?.innerWidth;

    // 只有非移动端（桌面端）才允许触发防抖 resize
    if (currentWidth >= BREAK_POINT) {
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(setRem, 100);
    }
  });
}